import { CongrupoDTO } from "@/application/dto/CongrupoDTO";
import { IHttpClient } from "@/application/ports/IHttpClient";
import { Congrupo } from "@/domain/entities/congrupo";
import { API_ENDPOINTS } from "../config/api.config";
import { ICongrupoRepository } from "@/domain/repositories/ICongrupoRepository";

export class CongrupoRepository
  implements ICongrupoRepository {

  constructor(
    private readonly httpClient: IHttpClient
  ) { }


  findById(_id: string): Promise<Congrupo | null> {
    throw new Error("Method not implemented.");
  }
  async create(
    table: string,
    data: Omit<Congrupo, 'id'>
  ): Promise<Congrupo> {
    const response = await this.httpClient.post<CongrupoDTO>(
      `/congrupo/${table}`,
      data
    );

    return this.mapToEntity(response.data);
  }

  update(_table: string, _id: string, _congrupo: Partial<Congrupo>): Promise<Congrupo> {
    throw new Error("Method not implemented.");
  }
  async findGroup(
    table: string,
    group: string
  ): Promise<Congrupo[]> {

    const response =
      await this.httpClient.get<
        CongrupoDTO[]
      >(
        API_ENDPOINTS.congrupo.bygroup(table, group)
      );
    console.log(response);

    return response.data.map(dto =>
      this.mapToEntity(dto)
    );
  }



  async findAll(
    table: string
  ): Promise<Congrupo[]> {

    const response =
      await this.httpClient.get<
        CongrupoDTO[]
      >(
        API_ENDPOINTS.congrupo.base(table)
      );
    console.log(response);

    return response.data.map(dto =>
      this.mapToEntity(dto)
    );
  }

  private mapToEntity(
    dto: CongrupoDTO
  ): Congrupo {

    return {
      id: dto.id,
      nombre: dto.nombre,
      grupo: dto.grupo,
      usuario: dto.usuario,
      fecha: new Date(dto.fecha)
    };
  }
}
